export default __webpack_public_path__ + "static/media/JustMeasureLogo.bdeb459f.png";